// extracted by mini-css-extract-plugin
module.exports = {"head":"index_head_3wm4y","title":"index_title_3dKFj","time":"index_time_2_j-m","content":"index_content_38BGo","tabs":"index_tabs_2Z72W"};